import { useQuery } from '@tanstack/react-query';

import { get, getNew } from '../api/ventura/contract';
import { isAchHost } from '../util/achAuth';
import { unwrapAchShowModel } from '../util/achEnvelope';
import { useConfig } from './useConfig';

function useContract(contractId: number) {
  const { apiHost, apiHostFor } = useConfig();

  const isNew = contractId === -1;

  // Contracts show opts into the per-domain flip: apiHostFor('contracts')
  // resolves to ACH iff contracts is flipped ON (migrated list + env gate),
  // else the plain Rails apiHost. When served by ACH the response adopts the D2
  // `{model}` envelope (RD-2), so unwrap it back to the bare contract the
  // consumer already expects — a no-op on Rails. getNew stays on apiHost: the
  // new-contract form is a Rails-only route, out of the flip scope.
  const contractsHost = apiHostFor('contracts');

  const query = useQuery({
    queryKey: ['contracts', contractId],
    queryFn: () =>
      isNew
        ? getNew(apiHost)
        : get(contractsHost, contractId).then((res) => unwrapAchShowModel(res, isAchHost(contractsHost))),
    enabled: isNew || Boolean(contractId),
  });

  return query;
}

export default useContract;
